import React from 'react'

import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { BasicInfoScreenValidationResult } from '../../../../../../../@types/validation-types'
import { TextInput } from '../../../../../../common/inputs/textInput/TextInput'
import { getDefaultClasses } from '../../../../../../../utils/style-utils'

const AuxiliaryAreaField: React.FC<FieldProps<BasicInfoScreenValidationResult>> = ({
  screenName,
  insertionData,
  validationMessages,
  wrapperClassName = getDefaultClasses('full'),
  onChange,
}) => {
  const { t } = useTranslation()
  return (
    <div className={wrapperClassName}>
      <TextInput
        id='auxiliary-area'
        propertyName='auxiliaryArea'
        placeholder=''
        label={<span>{t('wizard.screen.basicInfo.auxiliaryArea', 'Auxiliary Area')}</span>}
        value={insertionData.auxiliaryArea}
        maxLength={11}
        type='text'
        affixRight='unit'
        unitRight='sqm'
        errors={validationMessages?.auxiliaryArea ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}

export default AuxiliaryAreaField
